import {
  Button as ParallaxButton,
  type ButtonProps as ParallaxButtonProps,
} from '@adc/parallax-component-library';

const WIDTH_SIZES = {
  small: 32,
  medium: 180,
  large: 256,
} as const;

type WidthSize = keyof typeof WIDTH_SIZES;

type ButtonProps = ParallaxButtonProps & {
  width?: WidthSize;
  minWidth?: WidthSize;
  maxWidth?: WidthSize;
};

export const Button = ({
  width,
  minWidth,
  maxWidth,
  ...props
}: ButtonProps) => (
  <ParallaxButton
    {...props}
    // @ts-expect-error Parallax doesn't type Button width
    width={width ? WIDTH_SIZES[width] : undefined}
    minWidth={minWidth ? WIDTH_SIZES[minWidth] : undefined}
    maxWidth={maxWidth ? WIDTH_SIZES[maxWidth] : undefined}
  />
);
